import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  UserIcon,
  BookOpenIcon,
} from '@heroicons/react/24/outline';
import { useTenant } from '../contexts/TenantContext';

const navItems = [
  { path: '/dashboard', icon: HomeIcon, label: 'Home' },
  { path: '/hr-bot', icon: ChartBarIcon, label: 'HR Bot' },
  { path: '/practice', icon: ChatBubbleLeftRightIcon, label: 'Practice' },
  { path: '/learning-resources', icon: BookOpenIcon, label: 'Learning' },
  { path: '/profile', icon: UserIcon, label: 'Profile' },
];

const MobileNav: React.FC = () => {
  const location = useLocation();
  const { currentTenant } = useTenant();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 md:hidden">
      <div className="grid grid-cols-5 h-16">
        {navItems.map(({ path, icon: Icon, label }) => {
          const tenantPath = currentTenant ? `/${currentTenant.website_url}${path}` : path;
          const isActive = location.pathname === tenantPath;
          return (
            <Link
              key={path}
              to={tenantPath}
              className={`flex flex-col items-center justify-center space-y-1
                ${isActive
                  ? 'text-indigo-600 dark:text-indigo-400'
                  : 'text-gray-600 dark:text-gray-400'}`}
            >
              <Icon className="h-6 w-6" />
              <span className="text-xs font-medium">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;